module.exports = __webpack_public_path__ + "img/banking.2e484c6c.svg";